// extracted by mini-css-extract-plugin
export default {"fixedOuter":"fixedOuter__5GVD0","frameless":"frameless__9AGk9"};